import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Autocomplete } from '@material-ui/lab';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ROLES, ROLES_ID } from 'src/constants/roles';
import { useGetRoles } from 'src/hooks/roles';
import { COMMENT_TO } from 'src/constants/demands';
import { useSelector } from 'react-redux';
import {
  getRoleCurrentUser,
  isAdmin as isAdminSelector,
  isManager as isManagerSelector,
  isRepresentive as isRepresentiveSelector,
  isSuperAdmin as isSuperAdminSelector ,
  isConsultant as isConsultantSelector,
} from 'src/store/selectors/user';
import FilesField from 'src/components/FilesField';
import * as Yup from 'yup';
import { useListUsers } from 'src/hooks/users';
import pickBy from 'lodash/pickBy';

const useStyles = makeStyles((theme) => ({
  actions: {
    justifyContent: 'center',
  },
  btn_container: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
  },
  btn: {
    color: '#fff',
  },
  btn_no_selected: {
    backgroundColor: '#fff',
  },
  autorizar_btn: {
    backgroundColor: '#00b894',
  },
  autorizar_btn_no_selected: {
    color: '#00b894',
    border: '1px solid #00b894',
    '&:hover': {
      backgroundColor: '#00b894',
      color: '#fff',
    },
  },
  denegar_btn: {
    backgroundColor: '#d63031',
  },
  denegar_btn_no_selected: {
    color: '#d63031',
    border: '1px solid #d63031',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#d63031',
      color: '#fff',
    },
  },
  info_btn: {
    backgroundColor: '#0984e3',
  },
  info_btn_no_selected: {
    color: '#0984e3',
    border: '1px solid #0984e3',
    '&:hover': {
      backgroundColor: '#0984e3',
      color: '#fff',
    },
  },
  evaluar_btn: {
    backgroundColor: '#74b9ff',
  },
  evaluar_btn_no_selected: {
    color: '#74b9ff',
    border: '1px solid #74b9ff',
    '&:hover': {
      backgroundColor: '#74b9ff',
      color: '#fff',
    },
  },
}));


const stylesPopUp = makeStyles((theme) =>({
  actions: {
    fontSize: '16px',
    color: '#f44336',
    textAlign: 'center',
    backgroundColor: 'lightyellow'
  },
}));


// toRoles options depending on user role
const ROLES_OPTIONS = [ROLES.DOCTOR, ROLES.MANAGER, ROLES.REPRESENTATIVE];

const AddCommentForm = ({ demand, handleAddCommentDemand, closeDialog }) => {
  const userRole = useSelector(getRoleCurrentUser);
  const isManager = useSelector(isManagerSelector);
  const isAdmin = useSelector(isAdminSelector);
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const isRepresentive = useSelector(isRepresentiveSelector);
  const isConsultant = useSelector(isConsultantSelector);
  const classes = useStyles();
  const { t } = useTranslation(['demands', 'roles', 'rolesNames', 'users', 'common']);
  const [buttonSelected, setButtonSelected] = useState(COMMENT_TO.GESTORES);
  const { data: roles, isError: isErrorRoles } = useGetRoles({
    all: true,
  });
  const initialValues = {
    toRoleId: COMMENT_TO.GESTORES,
    comment: '',
    privateComment: '',
    attachments: [],
  };

  
  const validationSchema = Yup.object().shape({
    toRoleId: Yup.string().nullable().required(t('errors.toRole.required')),
    comment: Yup.string()
      .when(
      ['$isManager', '$isAdmin', '$isSuperAdmin'],
      (isManager, isAdmin, isSuperAdmin) => 
        !isManager && !isAdmin && !isSuperAdmin
        ? Yup.string().required(t('errors.comment.required'))
        : Yup.string().nullable()
    ),
    privateComment: Yup.string(),
    attachments: Yup.array().of(
      Yup.object().shape({
        descripcion: Yup.string().required(t('errors.attachments_values.descripcion.required')),
        archivo: Yup.string().required(t('errors.attachments_values.archivo.required')),
      }),
    ).nullable(),    
  });
  /*
  const validationSchema = Yup.object().shape({
    toRoleId: Yup.string().nullable().required(t('errors.toRole.required')),
    comment: Yup.string().required(t('errors.comment.required')),
    privateComment: Yup.string(),
    attachments: Yup.array().of(
      Yup.object().shape({
        descripcion: Yup.string(),     // ya no es requerido
        archivo: Yup.string(),         // ya no es requerido
      }),
    ).nullable(),
  });
 */

  const fastComment = (action, setFieldValue) => {
    setButtonSelected(action);
    
    setFieldValue(
      'toRoleId',
      action,
    );
  };

  const onSubmit = (values) => {
    const data = pickBy(values);
    return handleAddCommentDemand(data);
  };
  
  
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} 
        validate={(values) => {
        return validationSchema
          .validate(values, { context: { isManager, isAdmin, isSuperAdmin } })
          .then(() => ({}))
          .catch((err) => {
            return { [err.path]: err.message };
          });
      }}
    >
      {({
        errors,
        handleBlur,
        setFieldTouched,
        handleChange,
        setFieldValue,
        handleSubmit,
        isSubmitting,
        touched,  
        values     
      }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Box p={1}>
              <Grid container spacing={3}>
                {(isManager || isAdmin|| isSuperAdmin || isConsultant) && (                  
                  <Grid item xs={12}>
                    <Box className={classes.btn_container}>
                      
                        <Button
                          variant="contained"
                          className={
                            buttonSelected === COMMENT_TO.DOCTOR
                              ? `${classes.btn} ${classes.autorizar_btn}`
                              : `${classes.btn_no_selected} ${classes.autorizar_btn_no_selected}`
                          }
                          onClick={() =>
                            fastComment(
                              COMMENT_TO.DOCTOR,
                              setFieldValue
                            )                            
                          }
                        >
                          {t('buttons.comment_to_doctor')}
                        </Button>
                        <Button
                          variant="contained"
                          className={
                            buttonSelected === COMMENT_TO.GESTORES
                              ? `${classes.btn} ${classes.info_btn}`
                              : `${classes.btn_no_selected} ${classes.info_btn_no_selected}`
                          }
                          onClick={() =>
                            fastComment(
                              COMMENT_TO.GESTORES,
                              setFieldValue
                            )                        
                          }
                        >
                          {t('buttons.comment_to_gestores')}
                        </Button>
                        <Button
                          variant="contained"
                          className={
                            buttonSelected === COMMENT_TO.ASEGURADORA
                              ? `${classes.btn} ${classes.denegar_btn}`
                              : `${classes.btn_no_selected} ${classes.denegar_btn_no_selected}`
                          }
                          onClick={() =>
                            fastComment(
                              COMMENT_TO.ASEGURADORA,
                              setFieldValue
                            )
                          }
                        >
                          {t('buttons.comment_to_aseguradora')}
                        </Button>
                      
                    </Box>
                    {touched.toRoleId && errors.toRoleId && (
                      <Typography color="error" variant="body2" align="center">
                        {errors.toRoleId}
                      </Typography>
                    )}
                  </Grid>                  
                )}
 

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    maxrows={4}
                    error={Boolean(touched.comment && errors.comment)}
                    helperText={touched.comment && errors.comment}
                    label={t('fields.comment')}
                    name="comment"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    variant="outlined"
                    value={values.comment}
                  />
                </Grid>
                {(  ((isManager  || isAdmin || isSuperAdmin) && buttonSelected!== COMMENT_TO.DOCTOR) ||
                  (isRepresentive &&  buttonSelected=== COMMENT_TO.GESTORES)) && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      maxrows={4}                    
                      error={Boolean(touched.privateComment && errors.privateComment)}
                      helperText={touched.privateComment && errors.privateComment}
                      label={t('fields.privateComment')}
                      name="privateComment"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      variant="outlined"
                      value={values.privateComment}
                    />
                  </Grid>
                )}
                { false && (
                  <Grid item xs={12}>
                    <FilesField
                      field="attachments"
                      errors={errors}
                      touched={touched}
                      setFieldTouched={setFieldTouched}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      disabled={isSubmitting}
                      values={values}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </DialogContent>

          
          <DialogActions className={classes.actions}>
            <Button variant="contained" onClick={closeDialog}>
              {t('common:buttons.cancel')}
            </Button>
            <Button color="primary" variant="contained" onClick={handleSubmit}>
              {t('buttons.add_comment_demand')}
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};

AddCommentForm.propTypes = {
  demand: PropTypes.object,
  initialValues: PropTypes.object,
  handleAddCommentDemand: PropTypes.func,
  closeDialog: PropTypes.func,
};

export default AddCommentForm
;
